import { useEffect, useState } from 'react'

export interface Viewer {
    name: string
    organizerName: string
}

export const useViewer = (): { viewer: Viewer | null, ready: boolean } => {
    const [viewer, setViewer] = useState<Viewer | null>(null)
    const [ready, setReady] = useState(false)

    useEffect(() => {
        let active = true

        fetch('/api/auth/me')
            .then(response => response.ok ? response.json() : null)
            .then((data: { viewer: Viewer | null } | null) => {
                if (!active) return
                setViewer(data?.viewer ?? null)
                setReady(true)
            })
            .catch(() => {
                if (active) setReady(true)
            })

        return () => {
            active = false
        }
    }, [])

    return { viewer, ready }
}
